<template>
  <div class="historyMember">
    <div>
      <p class="historyMemberTitle">챌린저</p>
      <v-avatar size="72" class="profile-image" id="challenger">
        <img v-if="member" :src="challenger" :alt="member.challenger" />
      </v-avatar>
      <p v-if="member">{{ member.challenger }}</p>
    </div>
    <div>
      <p class="historyMemberTitle">서포터</p>
      <v-avatar size="72" class="profile-image" id="helper">
        <img v-if="member" :src="helper" :alt="member.helper" />
      </v-avatar>
      <p v-if="member">{{ member.helper }}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "Member",
  data() {
    return {
      member: undefined,
      challenger: undefined,
      helper: undefined,
    };
  },
  computed: {
    challengeId() {
      return this.$store.getters.challengeId;
    },
  },
  methods: {
    getMember() {
      // this.$axios
      //   .get("/challenges/" + this.challengeId + "/members")
      //   .then((response) => {
      //     this.member = response.data;
      //   });
      this.member = {
        challenger: "user1",
        helper: "user2"
      };
      this.challenger = require("@/assets/images/home/user1.png");
      this.helper = require("@/assets/images/home/user2.png");
    },
    getBackgroundImage() {
      // this.$axios
      //   .get("/challenges/" + this.challengeId + "/background")
      //   .then((response) => {
      //     this.challenger = response.data.challenger;
      //     this.helper = response.data.helper;
      //   });
    },
  },
  mounted() {
    this.getMember();
    this.getBackgroundImage();
  },
};
</script>
<style lang="scss" scoped>
.historyMember{
  margin: -40px -20px 32px;
  padding: 40px 20px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #fff;
  text-align: center;
  position: relative;
  background-color: #ffb5cc;

  >div{
    &:first-child{
      &::before{
        content: '';
        width: calc(100% - 148px);
        border-bottom: 1px dashed #fff;
        position: absolute;
        bottom: 72px;
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
  p{
    margin-bottom: 0;
    font-size: 14px;
  }
  .historyMemberTitle{
    margin-bottom: 8px;
    font-size: 16px;
    font-weight: 700px;
    letter-spacing: -0.5px;
  }
}
</style>